// extracted by mini-css-extract-plugin
var _1 = "Accessibility-module_accessibility_action__fz5syF";
var _2 = "Accessibility-module_accessibility_label__DusdrD";
var _3 = "Accessibility-module_accessibility_navbar__DfdFft";
var _4 = "Accessibility-module_accessibility_readable_hover__COxaR9";
var _5 = "Accessibility-module_accessibility_section__FOtwLg";
export { _1 as "accessibility_action", _2 as "accessibility_label", _3 as "accessibility_navbar", _4 as "accessibility_readable_hover", _5 as "accessibility_section" }
